var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 788.17 454.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00b95e;}.cls-2{fill:#202020;}.cls-3{fill:#262e00;}.cls-4{fill:#ffd3bc;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:#192b59;}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:#f2dad4;}.cls-12{fill:url(#linear-gradient-6);}.cls-13{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 12467.03,
    y1: 424.27,
    x2: 12489.77,
    y2: 441.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 12868.3, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8dc85e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#176ad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 336.49,
    y1: 37.68,
    x2: 293.48,
    y2: 32.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bfad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2dad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 285.04,
    y1: 91.45,
    x2: 431.65,
    y2: 202.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 432.57,
    y1: 154.11,
    x2: 434.76,
    y2: 191.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2bfad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f2dad4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 342.07,
    y1: 53.12,
    x2: 356.3,
    y2: 82.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 408.71,
    y1: 118.91,
    x2: 433.47,
    y2: 164.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6dbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb9a99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 295.77,
    y1: 426.68,
    x2: 318.51,
    y2: 443.92,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 450.92,
    x2: 788.17,
    y2: 450.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M787.25,448.49c1.16,0,.75-.38.92-.46C786.22,448.12,787.3,448.6,787.25,448.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "768.04 449.44 768.38 449.27 765.55 449.69 768.04 449.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M750.08,449.43c1.7.72,6.51-.11,9.71.14l.52.16,1.45-.57C757.87,449.25,752.82,449.63,750.08,449.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M740.5,447.89c.59.28-2.07.24,2.23.09l-.4-.08C741.94,447.91,741.41,447.91,740.5,447.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M742.33,447.9c1.89,0-1.24-.23,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M733.59,448.06l2.49-.24c-.52-.17-2.73-.21-1.91-.32C731.61,447.63,732.14,447.79,733.59,448.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M731.23,448.59l1.29-.11A2.29,2.29,0,0,0,731.23,448.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M735.26,448.26l-2.74.22c.36.12.4.35,1.26-.08C733.55,448.61,734.1,448.41,735.26,448.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M736.81,448.37c1.4.15,3.2.25.7.5C742.28,448.77,741.58,448.27,736.81,448.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M749.16,450.17l1.87.21,1.62-.24C751.84,450.26,749,450,749.16,450.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M718.07,447.69c-.16.16.84.41,1,.6l1.84-.17C720,448,718.2,447.92,718.07,447.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M719.09,448.29l-2.75.26C718.8,448.59,719.25,448.46,719.09,448.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "730.79 449.38 735.31 448.83 729.91 449.38 730.79 449.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "707.55 447.68 709.11 447.32 706.33 447.86 707.55 447.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M700.58,447.74c1.15-.29-1.59-.5-.37-.67a38.82,38.82,0,0,0-5,.52A27.58,27.58,0,0,1,700.58,447.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M692.8,447.92c.77-.07,1.57-.2,2.44-.33A22.34,22.34,0,0,0,692.8,447.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M711.65,448.48a5.28,5.28,0,0,0-2.17-.43l1.08.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M710.6,448.49l0,0-2.34,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M711.92,448.48h-.27A.26.26,0,0,0,711.92,448.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M723.57,449c-1.62.24-5,.5-1.73.86C723,449.56,721.13,449.35,723.57,449Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M713.27,449l2.92.09c-.06-.11-.58-.27.22-.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "711.84 449.15 713.27 449.01 712.18 448.98 711.84 449.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M697.81,448.32a33.7,33.7,0,0,1-4.21.23c1.67.08,3.4.13,5,.13C698.88,448.55,699.6,448.3,697.81,448.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M704,448.44l-.29,0C703.92,448.5,704.06,448.51,704,448.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M678.23,448.55l.25.08,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M698.93,448.76a10.13,10.13,0,0,0,2.72-.15c-.94,0-1.93.07-3,.07C698.54,448.74,698.52,448.78,698.93,448.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M688.51,448.12c.65.09,1.4.16,2.18.23A8,8,0,0,0,688.51,448.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M703.32,448.34h.19C703.1,448.23,703.15,448.28,703.32,448.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M703.32,448.34c-.65.07-1.16.17-1.67.27.77,0,1.48-.08,2.09-.15A2.1,2.1,0,0,1,703.32,448.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M673.57,451.29c.23-.39,3.53-.76,6.39-.34,2.81-.29,1-1.6-1.48-2.32-.09.17-.09.33-3,.56,1,.22,6.41.51,4,.87-3.82.2-3.13-.14-5-.35,1.58.49-4.88.72-4,1.44l3.36-.25C673.86,451,672.64,451.19,673.57,451.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M684,448.67l1.18-.05a31.52,31.52,0,0,1-4.11-.54c-2,.19-2.39.34-2.53.47l5.86.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M690.51,448.62c-.92.43-3.78.61-2,1.08,3.49,0,2.44-.36,4.53-.55-5.63.11,1.62-.24-2.45-.49,1.11-.07,2.1-.09,3-.11-1-.05-2-.12-2.91-.2l.13,0h0c.24.05.32.08,0,.05h-.12a.61.61,0,0,1-.26.16c-1.63-.09-.25-.11.26-.16,0,0,.06,0,.07-.06h0l-5.65.24C686.37,448.68,687.86,448.66,690.51,448.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M718.83,450.78c-.17,0-.17-.07-.18-.1C718.28,450.73,718.15,450.77,718.83,450.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M716.51,450.52a6.77,6.77,0,0,1,2.08-.19c1.16.13,0,.21.06.35.8-.12,2.81-.31.29-.52l-.4.06a20.19,20.19,0,0,1-4.79-.75A9,9,0,0,0,716.51,450.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M703.35,449.68l-4.7.21,2.39.37-.12-.22C703.59,450.12,703,449.85,703.35,449.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "677.69 448.33 678.32 447.88 675.6 448.52 677.69 448.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "671.59 448.39 671.81 447.99 670.2 448.23 671.59 448.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M327,453.3l-1.38.11C326.29,453.38,326.71,453.34,327,453.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337,453.33l.24-.2C336.8,453.24,336.61,453.32,337,453.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M521.63,448.43c-2-.37-4.26-.94-4-.49l.62.43A21.4,21.4,0,0,1,521.63,448.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M418.92,451l.59.13,1.36-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M417.5,452.82l-2.65-.28C415.45,452.64,416.3,452.73,417.5,452.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.43,453.76l-1.61.44C273.34,454.2,272.23,454,272.43,453.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M609.05,448.55c-1.74-.17-3.12-.24-4.33-.26C606.81,448.54,608.5,448.91,609.05,448.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331,448.69c-.85.08-1.21.17-1.19.27C330.64,448.88,331.14,448.8,331,448.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M599.71,448.29l.92.1c1.26-.07,2.54-.13,4.09-.1A17.16,17.16,0,0,0,599.71,448.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.45,453.4l-.45,0C74,453.41,74.16,453.41,74.45,453.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.77,449c.57,0,1.49,0,2.37,0A22,22,0,0,0,16.77,449Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M647,448.2c1.29,0,.2-.05,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M653.32,449.91c-.28,0-.49.12-.52.22A1,1,0,0,1,653.32,449.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M586.81,451h-.11C587.08,451.07,587,451.06,586.81,451Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M649,448.4c-.49-.06-1.05-.1-1.66-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M648.71,448.19l1.13,0C650,448.16,649.86,448.12,648.71,448.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M645.22,448.22c.74,0,1.43,0,2.09,0-.25,0-.36-.06-.29-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.53,452.24l-.28,0C179,452.38,179.52,452.35,180.53,452.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M487.92,452.94l.15,0-.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M483.27,453.26a11.7,11.7,0,0,1,4.61-.36l-1.54-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.09,453.42l3.27.39c-3.95.64-6.8.42-3.73,1,.46-1.36,12.69-.14,13.15-1.49l2.15.28c-.62,0-.72.07-1.33.05,4.19.66,3.12-1,8.51-.78,1.88.1,3.19.3,1.91.46l4.19-.34c1.22,0,.92.26-.29.24l6.39-.11-.05,0c.91-.21,3-.54,4-.68,1.62.19-.82.14-.4.31l3.54-.33c1.44.35-1.49.7-3.94.65,3.31,1.35,2.94-.35,10.07.45l-3.34.17c2.15.77,4.76.49,8.54,1-.9-.25-7.56-1.21-3.72-1.55a19.87,19.87,0,0,0,4.58-.12c0,.48,2,.36,4.57.34L361,454c2.73-.19,2.52-.52,4.13-.8,3.05.06,3.68.56,4.4,1,4.88.1-3.37-.79,2.41-.91a77.93,77.93,0,0,0,11.77-.4c2.85.22-.49.39.53.57l2.52-.51c.61,0,.41.17.31.25,2.13-.2.18-.64,3.52-.81.9-.71,6.85,1,11,.23,1,.18-.49.39-.18.64,5.67-.53,4.86-.38,9.52-1.09l4,.42c-2.91-.48.81-1.05,4.07-1.52-1-.23-1.91-.43-2.51-.53l5.21-.34c.63.1.1.32-.75.59l.95-.15c1.86.23.9.6-.43,1-.64-.13-1.27-.26-1.88-.4-1.28.39-2.49.82-2.22,1.2a11,11,0,0,1,1.71-.17c-.34.1-.55.2-.4.26a6,6,0,0,0,1.57-.24l1.19.71.28-.28,6.81.45c4.87-.72,9.11-1.78,16.84-2.07-1.92.52-.41.85-.52,1.47-2.1-.65-6,.28-10,.15,2.09.07,1.63.36,1.1.47l7.15-.6c-.17.51,1.51.38,3.38.59-1.41-1,5.33-.67,8.24-1,.18.34-.52.68-4.07.6,3.91.76,5.06-1.17,8.9-.53a4.6,4.6,0,0,0-1.68.12c2-.29,7-.06,5.81.24h-.86c5.75.12,17.5,0,18.36-.84.06.11-.75,1-1.1,1.2L490.27,450c-.9.73,2.57,2.47-2.2,2.89a32.57,32.57,0,0,0,5.95,0c-.94-.1-2.33-1.05-1-1.12a58.84,58.84,0,0,0,6.75,1.13c-1.4-.16.15-1.3,2.37-1.27-.35.18.18,1.14-.63,1.25l5.51-1.12c-1.37.2-.24.95,1,1.27-.57-.22,4.76,0,6.23-.09l-2.34-.26c6.22.17,6.15-1.58,12.32-1.52-.75.23-1.85,1.43,1.29,1.57a40.23,40.23,0,0,1,11.82-3.22l1.05.33,4.19-.37a141.17,141.17,0,0,1-13.92,3.4c2.32.26.64.39,4.13.36,1.23.31-1.9.47-2.93.48l8.12.2c-.36-.67,6.2-.67,5.89-1.23l-8.81.69c-.36-.67,5.1-1.9,10.84-1.78,1.47.26-1.09,1.19-1,1.42a30.07,30.07,0,0,1,6-.28l-2.44.36c3.2.25,5.22-.89,9.07-.25,1.32,0,4,.86,4.19.47-2.17-.77-2.59-3.14-1.15-3.72.47.05,7,.73,8.49,1.11,2.18.6-3.28,1.44-1.42,1.95a5.24,5.24,0,0,1,1.79-.48c1.39.16-.58.57,2.45.49.51-.69,6.16.05,1.43-.58,3-.2,3.15.14,6.63.11-1.11-.44,3.13-1.5,6.09-1.69-.17.17.5.39.82.5,6.07.06,9.33.37,15,.37.52.17,3.25.37,2.09.66a17.4,17.4,0,0,1,3.31-.37c3.38.59-3.9.1-1.32.8.22-.39,4.52-.54,7-.79-.77-.61-5.75-.12-8.24.13,0-.84,4.32-1.73,10.24-2.12,4.71-.21,2,.55,2.86.43,8.84.15,7.53-1.48,14.86-.87,2.92.54.14,1.07.78,1.46-3.83.2-5.88-.34-8.48-.32l3.2.26a26.68,26.68,0,0,1-5.17.15c2.44.49,14.93.1,21.74.54,1.22-.18,3.31-.36,2.32-.58l-2.16.08c-2-.44,4.06-.6,1.33-.81a57.63,57.63,0,0,1,10.21-.54l.77.62a11.18,11.18,0,0,0-3.81-.18c1.7-.27,6.25.83,8.11,0l-2.86-.43a61,61,0,0,1,10.11-.76c-1.64-.61-.83.07-3.4-.64,2.22.88-9.24,0-5.66.89-2.64-.83-4.56-.35-8-1.05.11.2,1.22.38-1.81.28a4.27,4.27,0,0,1-.67.18H649l.17,0c-.14,0-.15,0,.06,0a6.33,6.33,0,0,1,1.54.31c-1.5.46-6.32.45-8,.69-1.8-.1.75-.24-.23-.45l-2.44.36c-.24-.45-4.77-.75-.54-1l-3.81,0a40.46,40.46,0,0,0-7.24-.16c-1.8-.1-4.54.49-3,.14l-6,.28-.05-.11c-5.9-.06-12.15.74-18.89-.07a68,68,0,0,1-7.37.12l-.65-.38c-2.55.13-7.65-.39-8.75,0-2.75-1-12.38-.23-16.87-.41l-.17.51c-3.08,0-6,.11-9.88.31l.24.45c-3.3.37-8.5-.32-13.72-.27a7.87,7.87,0,0,1,2.62,0c-6.25-1-13.18.73-18.84,0a14.31,14.31,0,0,1-3.42,0l.35,0h-.58c-.63-.08-1.27-.17-2-.24.59.11,1.15.2,1.64.24-1.08,0-2.73.07-4.35.18l-.69-.48h-.38c-1.58-.18-1.27.23-.42.59-.82.08-1.57.18-2.15.29-1.28-.77-4.24.27-6-.56-1.09.4-8.14.3-9,1.15,0-.11-.53-.16.34-.17a26.63,26.63,0,0,0-5.22.05l-.77-.62-3.93.83c-2.4-.38-3.39-.59-1-1.06-5.74.72-4.66.27-9.54,1l.24-.4c-1.74,0-4.53.55-5.58.22-3.9-.75-19.31-.1-29.32-.8,1.94,1.16-4.66-.53-5.05.38-.59-.28-2-.43-.36-.67-5.11.27-7.68-.44-11.21.32-.58-.28,1.1-.4.58-.57a7,7,0,0,1-2.16.08c-.52-.17.75-.23,1.56-.35-5.22,0-5.75.89-6.13,1.69a12.55,12.55,0,0,0-5.88.2c-.92-.26-2.45-.53.79-.63-1.83,0-11.15-.38-11.33.26a13.39,13.39,0,0,0-3,0c-4.09,0-4.45-.09-8.47,0l1.11.1c-1.59.77-3.34.18-6.58.27l.09-.08c-7.43-.56-3.21.27-10.54-.37l.4.48c-.69,1-6.5-.61-10.76-.21l1.54.27c-2.32.35-6.5-1.4-8.83-1.53-.51-.09.8-.14,1.51-.21-6.11-.61-.79.63-5.34.77-.84-.34,1.08-.86-2-.92-1.52-.28-8.89,1.1-13.07.45.92.26,1.84.52-.28.72-3.24.09-8.76-1-11.69-.17-.41-.07-.57-.14-.59-.2-2.47.21-8,.35-9.54.8-2.29-1.66-15.41.8-15.36-.72l-7.62.08.2-.16a30.73,30.73,0,0,0-8.31.63c-1.13-.1-.3-.24-.21-.32-7.12-.31-7.83-.25-13.8.51l-.62-.49c-1.62.29-10.29-.78-17.28-.2.07-.06.22-.15.77-.22-7.86.58-18.81-1.38-21.69.43l-5.18.44c6.71.14-1,.79,1.76,1.09-2.64.1-6.82-.55-3.58-.64l.51.09c1.19-.94-8.34-.34-8.16-1-13.2.05-26.06-.47-38.43-.51l1.43.73-4.32,0c-1.13-.17-1.51-.57,1.56-.54a12.42,12.42,0,0,0-5.25.5c-6-.29,2.36-.85.51-.87l-2.51.06.57.08a22.7,22.7,0,0,1-5.92.58c-2.34-.14-1.2-.45-2.12-.48,0-.05-.3-.07-1.41,0l-5.43-.06,2.17.58c-2.41.28-5.11,0-2.6.62-3.68-1-20.27-.36-22.53-.67a79,79,0,0,1-10.83.36c1,.12,1.64.77-1.92.69,1.3-1.34-6.51-.58-9.39-1.55,2.57.64-10.11.16-6.08,1.07-3-.11-.18-.5-2.43-.82-7.07.52-15.57-.34-24.3-.16-.14.18,1.32.44-.55.71l-4.61-.88c-1.73.08-1.59,1-4.74.4.45.15,1.11.37,0,.43-17.1-.86-35,.7-52.33-.91,2.35.34.79.38-1,.39,1.17.08,0,.43.2.67L12.07,449c-1.33.66-7.8,0-8.56.68l2.3-.12c-3.06.75,4.29,1.66,3.84,2.62,3.43-.85,9,1.26,14.67,0,1.25.2-1.06.31-.39.53a19.17,19.17,0,0,1,6.34-.31l-.36.1c9-.1,12.81.31,22.89.58l-.75-.48a27.43,27.43,0,0,1,3.64.33c2.48-.72-6.08,0-3.82-.83,2.87,1,15.27,0,17.21,1.11,3.33,0-1-.55,2.35-.54l.88.29.85-.38c2.18.07,3.28.44,3.36.69-.53,0-1.5.07-2.07.09,2.83.35,8-.12,9,0l-3.2-.18c9.09-.28,20.18.11,29-.49l-.67-.22c6.71-.42,5.37.24,12.73.05l-.26.05a36.61,36.61,0,0,1,5.45-.31c-1.86.27,3.5.51,1.06.8,7.27-.44,3.6-.35,8.4-1.18l1.11.37a20.17,20.17,0,0,1,5.45-.6c-3,.31,2.35.56-1,1,7.71.81,11.46-.82,15,.37,3.54-1-6.68-.57-4.7-.79-1.66-.34,2.93-.77,5.35-.66s4.19,1.31,10.39,1.29c-.61,0-.66.07-1.27.07,2.32.26,4.55-.36,7.39.07,1.6-.62,3.7,0,4.16-.76l-5.69.19c3.22-.21,6.25-1.14,11.56-.69a21.87,21.87,0,0,1-3.08.49c1.55.23,3-.16,4.6.08-.46.8-6.91.18-10.37.78,1.67.33,6.54-.57,4.8.28,2.5-1.09,6.11.14,10.31-.69l-.28.47a25.91,25.91,0,0,1,3.27-.28l-2.22.61c3.4-.52,6.56.46,9.82.17-6.83,0-1.53-.57-4.42-.91,8.42-.64,4.84,1.24,14.27,1-1.28.07-4.79-.28-2.8-.5a42.52,42.52,0,0,1,5.27.52c6.25-.09-1-.48,1.7-.78,2.13.58,3.07-.23,5.81-.42l0,.49c7.11.31,1.88-1,8.29-.63l-2.71.66,3.34-.17-.68.55a41.42,41.42,0,0,1,8.32-.15c-.83-.34.47-.87,3.62-.89,2.15.29-1.2.46,3.27.39a6.92,6.92,0,0,1-4.06.24c-.2.15-1,.3-1.2.46a56.68,56.68,0,0,0,7.43.07,15.5,15.5,0,0,1-1.75-.12l6.48-.66c1,.18.21.32-.59.46,1.31,0,2.22-.27,4.15-.31-.5.39-.38.8-3.11,1l6.17-.43c.42.17,3.17.46,2.37.61,3.42.23,8.39-.76,12.93-.46a8.06,8.06,0,0,1,1.67-.2c4.27.09,8.05.57,13.1,0l2.87.7c4-.16-3.88-.88,2.71-1.15,4.66-.22,1.74.6,3.37.8a36.56,36.56,0,0,1,10.65-.51C305.53,453.48,304.41,453.37,303.09,453.42Zm48.81-.31c-.94.1-2.83.42-3.52.13C349.46,452.69,350.29,453,351.9,453.11ZM426.11,452a9.34,9.34,0,0,1-3-.1A19.94,19.94,0,0,1,426.11,452Zm206.71-3.36-.1,0C630.61,448.43,631.36,448.5,632.82,448.59Zm4.39.21c.44-.07.41-.13.22-.2a10,10,0,0,1-2.41.1A5.22,5.22,0,0,0,637.21,448.8ZM166.7,449l.85.13C165.62,449.26,166.16,449.13,166.7,449Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M417.7,452.61a.63.63,0,0,1-.41-.26C416.92,452.43,416.91,452.52,417.7,452.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M272.73,453.68h-.15a.39.39,0,0,0-.15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M569.34,452.89a9.65,9.65,0,0,1-1.74-.25C567.55,452.76,568,452.86,569.34,452.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M660.42,448l-2.8.13a14.65,14.65,0,0,1,2.52.15C660.08,448.15,659.55,448,660.42,448Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M684.78,451c.41-.06.87,0,1.28-.07l-.11-.22C684.2,450.69,683,450.87,684.78,451Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M663,449.58c.22.41,2,.27,4,.2h-.35C667.2,449.21,665.11,449.4,663,449.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M667.43,449.76c.6,0,1.22,0,1.81,0C669.47,449.53,668.51,449.71,667.43,449.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M642.76,448.53c.94.11.59-.52,1.12-.35C644.92,447.66,637.66,448.8,642.76,448.53Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "664.61 450.92 663.91 450.42 662.81 450.82 664.61 450.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M649.09,450.55l3.14.14c-.05-.08.35-.13.84-.17A24.53,24.53,0,0,0,649.09,450.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M653.07,450.52a20.16,20.16,0,0,0,2.53-.08C655.06,450.44,653.88,450.46,653.07,450.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "660.32 451.07 659.39 450.97 657.17 450.93 660.32 451.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M615.32,450.46l-3.42.14c-.35.17.58.28,1.86.21C614.58,450.69,615.85,450.62,615.32,450.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M625.69,451.83a5.28,5.28,0,0,1-1.51-.38l-.11.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M615.69,452c-.34.18-5,.5-.63.46C615.41,452.26,618.84,452.12,615.69,452Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "564.04 451.19 564.91 451.18 564.78 450.16 564.04 451.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M518.51,453.62c4.06.25,1-.62,4.63-.32,1-.24-3-.25-2-.46C518.67,453.1,517.38,453,518.51,453.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M521.12,452.84c.39,0,.81-.08,1.25-.15A12.14,12.14,0,0,0,521.12,452.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.2 448.47 4.59 448.26 6.27 448.6 7.2 448.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.18,449.23l-.61-.65L0,449.17A8.63,8.63,0,0,1,2.18,449.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M359.16,454.42l.2-.16a7.09,7.09,0,0,0-2.24-.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "323.73 453.93 324.34 453.95 323.2 453.36 323.73 453.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M294,454.68c1.22,0,2.65-.1,3.86-.08C295.21,454.71,293.67,454,294,454.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M662.84,342.17a6.11,6.11,0,1,0-12.07,1.89c.88,5.68,2,23.51-4.16,30.68a8.21,8.21,0,0,1-5,2.85l.56-33.94a8.83,8.83,0,1,0-17.66.07l1.6,64.41a8.22,8.22,0,0,1-5.17-2.88c-6.15-7.17-5-25-4.15-30.68a6.11,6.11,0,0,0-12.07-1.88c-.44,2.8-4,27.75,6.94,40.5a20.69,20.69,0,0,0,14.75,7.25l.7,28h13.33l1-58.58a20.6,20.6,0,0,0,14.45-7.23C666.81,369.93,663.28,345,662.84,342.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.79,383.16a3.89,3.89,0,1,0-7.69,1.2c.56,3.62,1.27,15-2.65,19.56a5.23,5.23,0,0,1-3.16,1.81l.35-21.63a5.63,5.63,0,1,0-11.25,0l1,41.06a5.24,5.24,0,0,1-3.3-1.83c-3.92-4.57-3.2-15.93-2.65-19.56a3.89,3.89,0,1,0-7.69-1.2c-.28,1.79-2.53,17.69,4.42,25.82a13.22,13.22,0,0,0,9.41,4.62l.45,17.87h8.49l.62-37.34A13.15,13.15,0,0,0,89.37,409C96.32,400.85,94.07,384.94,93.79,383.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M394.28,392.57s-.25,15,0,16.47-5.86,10.28-8.36,9.89-7.5-1.22-8.22-2.05-.41-2.8-.15-4.6,2.13-18.1,2.13-18.93S391.51,390.29,394.28,392.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M384.59,408.18c-3.13,1.69-4.88,6.83-5.33,6.9S378,415,378,414.51s.13-2.23-.44-2.23-1.21,2.8-1.34,6.86-1.57,13.76,0,15c1,.78,10,5.53,10.29,6.16s-.19,5.09.58,5.79,2.54,2.41,3.93,2.47,9.47.89,13.28,0,8.64-2.73,8.77-3.24-1-11.3-2.16-12.64S401,419.4,400.29,418.32a12.33,12.33,0,0,1-1.21-5.21c0-1.53-1.38-4.85-3.94-5.65S386.94,406.91,384.59,408.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M303,401.23s0,8.72-.25,10.22,5.86,10.27,8.36,9.89,7.5-1.23,8.22-2.06.4-2.8.15-4.59-1.87-11.85-1.87-12.68S305.8,399,303,401.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M311.07,208.82c-3.54,12.86-10.23,56.93-10.23,78.35s-2.14,76-2.14,84.32-.9,28.89,1.25,30,7.15,4.29,13.94,3.22,8.58-5.36,8.76-9.3,1.78-32.17,3.39-43.07,7.33-31.93,11.08-45.45,12.51-40.72,14.84-40.62,16.79,59.69,18,63.06,3.5,51.36,3.65,55.38,0,7.91,2.54,9.55,10.28,5.66,14.31,6,6.71-6.11,7.46-8.05S400,326,399.51,308.42s.91-50.43.1-61.14-3.43-33.64-5.1-38.46S311.07,208.82,311.07,208.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M286.08,59.29c3.38-3.75,19.14-21.51,22.26-22.14s10.74-2,12.44-3.75,8.87-24.28,6-28.38-13.8-2.94-17.12,4-3.16,10.63-8.64,15.45-29.37,24.34-31.59,26.32,2.18,11.55,5.67,13.21S286.08,59.29,286.08,59.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M329.63,64.7c-8.05,1.69-21.43,3.12-25.84,4.54S282,76.78,282.1,74.18s8-14,6.62-15.19-10-2.6-11.42-4.42S273.92,48.47,272,49s-24.53,21.55-23,29.6c3.64,19,57,32.82,58.23,41.11s-4.14,87.67-1.21,90.6,33.85,14.12,49.44,15.1,42.93-4.46,44.42-8.56-7.61-83-6.55-83,1.35,24.84,13.22,31.26c7.84,4.24,18.62-.13,20.69-2.47s-7.37-35.35-11.64-46.48-8.35-34.14-18-42.31-23.26-6.77-27.95-8.69-20.42-.55-24.39-1S329.63,64.7,329.63,64.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M430.19,147.71s-13.88,4.19-15,5.64-3,7.22,0,9.62,6.31,4.21,9.87,1.43,6.83-6.51,8.89-7,8.23.41,10.82-.6,7.5-20.65,5.52-21.84S430.19,147.71,430.19,147.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M329.69,62.05c-4.48-.93-13.12-9.39-13.92-18-.77-8.38-6.93-31.91,14.5-40.73,20.11-8.28,40.81.24,43.78,10.45,2.78,9.53-20.82,10-29.48,16.17s-9.24,10.34-11.4,9.36S329.69,62.05,329.69,62.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M329.33,45.28c-.28,3.84-1.25,22.39.36,25.12,1.47,2.51,4.09,9.79,14.37,9.47s16.94-10.6,17.51-11.8-.65-16.06-.65-18.55-13.81-8.35-19.35-8.19S329.6,41.68,329.33,45.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M330.27,45.34c1.16,0-.21,7,1.9,9.34S343.41,69,353.08,67.86c8.36-1,7.16-8.22,8.37-14.16,1.09-5.38,4.57-5.85,5.79-19.91.47-5.45,3-14-1.68-15.55s-22.47-5.77-26.88,0-4.83,19.64-7.14,17.86-7.15-10.5-10-5.78S324.08,45.52,330.27,45.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M404.94,117.28l-28.15,35.58a2.79,2.79,0,0,0,2.24,4.53l52-.88a2.8,2.8,0,0,0,2.19-1.12l26.59-35.53a2.54,2.54,0,0,0-2-4.06l-50.68.42A2.74,2.74,0,0,0,404.94,117.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M449.44,131.61c-2.73.28-6.71,1.82-6.71,3.25s3.19,1.82,4.07,2,2,.41,1.71.85-1,2.64-2.75,2.25-9.48-.49-11-.49-3.25,1-3.36,2.15-.44,1.32-1.32,1.37-2.48.88-2.48,2.32,3.54,2.72,3.54,3.22,6.94,4.75,8.3,5.53,3.9,2.8,5.33,2.8,3.83-1.36,4-3.33,3-3.4,3-4.37-.9-1.68-.79-2.29,2.58-1.47,2.58-3-1-3.62-1.11-4.26-.72-2-.15-2.22,2.58-2,2.22-3.76S450.71,131.48,449.44,131.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M312.46,410.59c3.12,1.69,4.88,6.83,5.32,6.89s1.27-.06,1.27-.57-.13-2.22.45-2.22,1.2,2.79,1.33,6.86,1.57,13.76,0,15c-1,.77-10,5.53-10.29,6.16s.19,5.08-.57,5.78-2.54,2.41-3.94,2.48-9.46.89-13.28,0-8.63-2.73-8.76-3.24.95-11.31,2.16-12.64,9.91-13.28,10.61-14.36a12.29,12.29,0,0,0,1.2-5.21c0-1.52,1.38-4.85,4-5.65S310.11,409.32,312.46,410.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.fe180b11269ed46f1ab4d208b06a6f7d.svg";
export { ForwardRef as ReactComponent };